export default {
    state: {
        index: 0,
    }
}
